import { Link } from 'react-router-dom';

// Cross SVG Component
const CrossIcon = ({ className }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 4v16m-4-8h8" />
  </svg>
);

export function Footer() {
  return (
    <footer className="bg-ocean-900 text-center py-12 border-t border-ocean-800 relative overflow-hidden" data-testid="main-footer">
      {/* Top gradient line */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-px bg-gradient-to-r from-transparent via-gold-500 to-transparent opacity-30" />
      
      <div className="max-w-4xl mx-auto px-4">
        <CrossIcon className="w-8 h-8 text-gold-600 mx-auto mb-6 opacity-50" />
        
        <p className="font-cinzel text-gold-400 text-xl mb-4">Couleurs de Joie</p>
        
        <p className="text-gray-400 text-sm mb-8 font-light max-w-lg mx-auto">
          Guided by faith, brought to life through art. May joy and light fill your heart today and always.
        </p>
        
        {/* Quick Links */}
        <div className="flex justify-center gap-8 mb-8 text-sm">
          <Link to="/sanctuary" className="text-gray-400 hover:text-gold-400 transition font-cinzel uppercase tracking-wide" data-testid="footer-link-sanctuary">
            Art Area
          </Link>
          <Link to="/moments" className="text-gray-400 hover:text-gold-400 transition font-cinzel uppercase tracking-wide" data-testid="footer-link-moments">
            Moments
          </Link>
          <Link to="/contact" className="text-gray-400 hover:text-gold-400 transition font-cinzel uppercase tracking-wide" data-testid="footer-link-contact">
            Contact
          </Link>
        </div>
        
        <p className="text-gray-500 text-xs">
          © {new Date().getFullYear()} Glaucia Veronica Juarez de Leon. All Rights Reserved to the Glory of God.
        </p>
        
        <Link 
          to="/admin" 
          className="inline-block mt-4 text-gray-600 hover:text-gray-400 text-xs transition"
          data-testid="footer-admin-link"
        >
          Admin
        </Link>
      </div>
    </footer>
  );
}
